import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/styles';

import {
  getCustomMenuItemsAction,
  userPoints,
  featureByName,
} from 'actions/app.actions';
import {
  menuSelector,
  tokenSelector,
  userInfosSelector,
  featureSelector,
  appConfigSelector,
} from 'reducers/app.reducer';
import { ROUTES } from '../../../constants';
import { getFormattedMenuItems } from './helper';
import SharedHeader from '../SharedHeader';
import AppLogo from '../AppLogo';
import { ICustomTheme } from 'interfaces';
import { usePermissions } from 'core/utils/use-permissions.hook';
import useLogout from 'core/utils/use-logout.hook';
import HidenHeaderWrapper from './HidenHeaderWrapper';

export const Header = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const matchWithAuthPage = useRouteMatch({
    path: ROUTES.LOGIN,
    strict: true,
    sensitive: true,
  });
  const token = useSelector(tokenSelector);
  const { customMenuItems, loading } = useSelector(menuSelector);
  const storeFeature = useSelector(featureSelector('use_store'));
  const contactFeature = useSelector(featureSelector('display_contact_tab'));
  const {
    id,
    profile,
    points: totalRewardsValue,
    userRoles,
  } = useSelector(userInfosSelector);
  const { programUrl } = useSelector(appConfigSelector);
  const { canAccessBo } = usePermissions(userRoles);

  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  const canAccessStore = storeFeature?.data?.enabled;
  const canAccessContact = contactFeature?.data?.enabled;
  const isStoreEnabled = storeFeature?.data?.enabled;

  const history = useHistory();
  const navigate = (url: string) => {
    history.replace(url);
    // window.location.replac(url);
  };

  useEffect(() => {
    if (token) {
      if (!loading) {
        dispatch(getCustomMenuItemsAction.request());
      }
      if (id) {
        dispatch(userPoints.request(id));
      }
      if (!storeFeature?.isLoading) {
        dispatch(featureByName.request('use_store'));
      }
      if (!contactFeature?.isLoading) {
        dispatch(featureByName.request('display_contact_tab'));
      }
    }
  }, [token, id]); // eslint-disable-line react-hooks/exhaustive-deps

  const menuItems = getFormattedMenuItems(
    customMenuItems,
    canAccessStore,
    canAccessContact,
  );

  if (!!matchWithAuthPage) {
    return null;
  }

  const colorsPaletteFromBO = theme.colors.paletteFromBO;

  return (
    <HidenHeaderWrapper>
      <SharedHeader
        menuItems={menuItems}
        isMenuItemsLoading={loading || storeFeature?.isLoading}
        userFirstname={profile?.firstName || '-'}
        totalRewardsValue={totalRewardsValue}
        isStoreEnabled={isStoreEnabled}
        appLogo={
          <AppLogo
            style={{
              width: '100%',
              maxWidth: 188,
            }}
          />
        }
        routes={ROUTES}
        colorsPaletteFromBO={colorsPaletteFromBO}
        programUrl={programUrl}
        canAccessBo={canAccessBo}
        userRoles={userRoles}
        t={t}
        useLogout={useLogout}
        navigate={navigate}
      />
    </HidenHeaderWrapper>
  );
};

export default Header;
